import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInformationSkipped } from '../redux/actions/cart'
import { isB2B } from '../utils/constants'
import { RootState } from '../redux/reducers/rootReducer'

/**
 * État effectif « étape /information sautée », robuste au rafraîchissement.
 *
 * - Lit le flag persisté (posé par /information lors du skip réel) ;
 * - sinon le redérive depuis l'état utilisateur (connecté + adresse), ce qui
 *   reproduit la condition de redirection automatique de /information ;
 * - resynchronise le flag redux pour les navigations suivantes.
 *
 * À utiliser sur les pages post-information (shipping, order-reference, payment)
 * pour masquer l'onglet « Information » du stepper même après un refresh.
 */
export function useInformationSkipped(): boolean {
  const dispatch = useDispatch()
  const stored = useSelector(
    (state: RootState) => state.cart?.informationSkipped
  )
  const isLoggedIn = useSelector((state: RootState) => state.user?.isLoggedIn)
  const addressCity = useSelector(
    (state: RootState) => state.user?.user?.address?.city
  )
  const billingAddress = useSelector(
    (state: RootState) => state.cart?.item?.billingAddress
  )

  const derived = !!isLoggedIn && !!addressCity && (!isB2B || !!billingAddress)
  const effective = Boolean(stored) || derived

  useEffect(() => {
    if (effective && !stored) {
      dispatch(setInformationSkipped(true))
    }
  }, [effective, stored, dispatch])

  return effective
}
